/**
 * The standing offer, after the full-screen step has been closed.
 *
 * It exists because the step is dismissible and the reason for it is not: a
 * browser tab cannot receive a reminder, so someone who taps "not now" has
 * chosen a version of Larder that cannot do the one thing it is for. The banner
 * keeps the door open for the rest of the session without covering anything.
 *
 * A row in the flow rather than a floating bar. A fixed strip would sit on top
 * of the list, and the bottom of this screen is already spoken for — the nav
 * and the add button both live there, in thumb reach, and neither can be
 * pushed up by a promo.
 */
export function InstallNudge({
  onOpen,
  /** Chromium with a live prompt: the button really is one tap. */
  oneTap,
}: {
  onOpen: () => void;
  oneTap: boolean;
}) {
  return (
    <button
      type="button"
      className="install-nudge"
      onClick={onOpen}
      data-testid="install-nudge"
    >
      <span className="install-nudge-icon" aria-hidden="true">
        📲
      </span>
      <span className="install-nudge-text">
        <strong>Add Larder to your home screen</strong>
        <span className="install-nudge-sub">
          {oneTap
            ? "One tap. Reminders only reach an installed app."
            : "Reminders only reach an installed app — not a browser tab."}
        </span>
      </span>
      <span className="install-nudge-go" aria-hidden="true">
        →
      </span>
    </button>
  );
}
